// ante-react-kit/src/components/AntQuickPopup/QuickPopupRegistry.js
const _registry = new Map();
const _listeners = new Set();

const QuickPopupRegistry = {
    register(table, Component, options = {}) {
        if (!table || typeof table !== 'string') throw new Error('register: table required');
        if (!Component) throw new Error('register: Component required');
        _registry.set(table, { Component, options });
        _listeners.forEach((fn) => fn());
    },

    unregister(table) {
        _registry.delete(table);
        _listeners.forEach((fn) => fn());
    },

    get(table) {
        return _registry.get(table) || null;
    },

    has(table) {
        return _registry.has(table);
    },

    list() {
        return Array.from(_registry.keys());
    },

    onChange(fn) {
        _listeners.add(fn);
        return () => _listeners.delete(fn);
    }
};

export default QuickPopupRegistry;
